const FILTERS = ['pending_approval', 'approved', 'deletion_requested', 'archived', 'rejected'];
const LABELS = {
  pending_approval: 'Pending Approval',
  approved: 'Approved',
  deletion_requested: 'Deletion Requests',
  archived: 'Archived',
  rejected: 'Rejected'
};

const TournamentFilterBar = ({ value, onChange }) => (
  <div className="flex gap-2 overflow-x-auto pb-2">
    {FILTERS.map((s) => (
      <button
        key={s}
        onClick={() => onChange(s)}
        className={`px-4 py-2 rounded-full text-xs font-semibold whitespace-nowrap uppercase ${
          value === s ? 'bg-[#F97316] text-white' : 'bg-white border border-gray-200 text-gray-700'
        }`}
        data-testid={`filter-${s}-btn`}
      >
        {LABELS[s] || s}
      </button>
    ))}
  </div>
);

export default TournamentFilterBar;
